import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import {FilterCategory, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {StatusPageList} from "@/lib/types/statuspages.ts";
import {StatusPagesFilters} from "@/pages/statuspages/list/components/StatusPagesFilters.tsx";

interface StatusPagesControlBarProps {
  search: string;
  setSearch: (search: string) => void;
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
  items: StatusPageList[];
}

export const StatusPagesControlBar = ({
  search,
  setSearch,
  filterSets,
  onFilterSetChange,
  items,
}: StatusPagesControlBarProps) => {
  return (
    <ActionBarWrapper
      className="mb-3"
      left={
        <>
          <SearchInput value={search} onChange={setSearch} variant="tableControlBar" />
          <StatusPagesFilters filterSets={filterSets} onFilterSetChange={onFilterSetChange} items={items} />
        </>
      }
    />
  );
};
